import React, { useEffect } from 'react';
import { Shelf, Stack, Text, Heading, Box } from 'chaser-components';
import PageContainer from '../../../../components/PageContainer/index';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import fetchLicenseDetails from '../../duck/actions/licenses';

import style from './LicenseDisplay.module.scss';

const LicenseDisplay = () => {
  const totalSize = useSelector(state => state.clientsReducer.totalSize)
  const {
    issuedLicensesCount,
    totalLicensesCount,
    connectedCount,
    chasingCount,
    error,
  } = useSelector(state => state.licensesReducer);
  const bundleId = useSelector(state => state.loginReducer.bundle);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLicenseDetails(bundleId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bundleId])

  return (
    <PageContainer className={style.header}>
      <Box padding="vertical">
        <Shelf justifyContent="space-between" alignItems="center" className={style.licenseRow}>
          <Heading>Clients</Heading>
          <Shelf>
            <Stack gap="xsmall">
              <Text size="xsmall" color="Mid Neutral 1">Licences</Text>
              <Text weight="bold" size="medium">
                {issuedLicensesCount}
                <Text as="span" size="medium" baseline={false} color="Mid Neutral 1">/{totalLicensesCount}</Text>
              </Text>
            </Stack>
            <div className={style.vl} />
            <Stack gap="xsmall">
              <Text size="xsmall" color="Mid Neutral 1">Connected</Text>
              <Text size="medium" weight="bold">{connectedCount}</Text>
            </Stack>
            <div className={style.vl} />
            <Stack gap="xsmall">
              <Text size="xsmall" color="Mid Neutral 1">Chasing</Text>
              <Text size="medium" weight="bold">{chasingCount}</Text>
            </Stack>
          </Shelf>
        </Shelf>
      </Box>
      <div>
        <input
          className={style.licenseClientsTab}
          id="licensedclients"
          checked
          type="radio"
          name="licensedclients"
        />
        <label className={style.tabLabel} data-testid="clients-label" htmlFor="licensedclients">
          All clients (
            {error ? '-' : totalSize}
            )
        </label>
      </div>
    </PageContainer>
  );
}

export default LicenseDisplay;

LicenseDisplay.propTypes = {
  totalSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  bundleId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  issuedLicensesCount: PropTypes.number.isRequired,
  totalLicensesCount: PropTypes.number.isRequired,
  connectedCount: PropTypes.number.isRequired,
  chasingCount: PropTypes.number.isRequired,
  error: PropTypes.string,
};

LicenseDisplay.defaultProps = {
  error: undefined,
};
